module.exports = __webpack_public_path__ + "img/grid-box.252c5b95.svg";